// Browser-session submit cooldown (~25s) to throttle repetitive spam scripts.

const STORAGE_KEY = 'lqe_last_submit_ts';
const COOLDOWN_MS = 25000;

export const COOLDOWN_MESSAGE = 'Please wait a few seconds before submitting again.';

export const isCoolingDown = () => {
  try {
    const ts = Number(sessionStorage.getItem(STORAGE_KEY) || 0);
    return Boolean(ts) && Date.now() - ts < COOLDOWN_MS;
  } catch {
    return false;
  }
};

export const markSubmitted = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    /* storage unavailable — skip */
  }
};
